import { lazy, type ComponentType } from 'react';
import { isChunkLoadError, handleChunkError } from './chunkRetry';

/**
 * Drop-in replacement for React.lazy() that auto-reloads once on chunk load errors
 * (e.g. when a deploy invalidates old hashed JS files).
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    factory().catch((error: unknown) => {
      if (isChunkLoadError(error) && handleChunkError()) {
        // Page is reloading — return a never-resolving promise to keep Suspense spinner visible
        return new Promise<never>(() => {});
      }
      throw error;
    }),
  );
}
